import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from '../../common/api/emerald-request';
import { Denominations } from '../../common/interfaces/dtos/ITender';
import { EmeraldRequestParams } from '../../common/interfaces/requests/EmeraldRequestParams';

const DENOMINATIONS_ENDPOINT = '/denominations';

interface DenominationTypeRequestOptions {
  isoCurrencySymbol: string;
}

export const getTenderDenomination = async (
  requestType: DenominationTypeRequestOptions,
): Promise<Denominations> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `${DENOMINATIONS_ENDPOINT}/denomination`,
    method: 'GET',
    params: requestType,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<Denominations>(emeraldRequestParams);
};

export const getTenderDenominations = async (): Promise<Denominations> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `${DENOMINATIONS_ENDPOINT}/denominations`,
    method: 'GET',
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<Denominations>(emeraldRequestParams);
};
